import { useSetJaneDeviceId } from '@jane/monolith/common/hooks/useSetJaneDeviceId';

export const SetJaneDeviceId = () => {
  useSetJaneDeviceId();

  return null;
};
